import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsPageRoutingModule } from './tabs-routing.module';
import { TabsPage } from './tabs.page';
@NgModule({
  declarations: [
    TabsPage
  ],
  imports: [
    IonicModule, 
    CommonModule, 
    FormsModule, 
    TabsPageRoutingModule
  ],
  exports:[
    TabsPage
  ]
})
export class TabsPageModule {}
